import moment from 'moment';

export const toSimpleDateString = (date, format = 'DD-MMM-YYYY HH:mm:ss') =>
  moment(date).format(format);

export const toSimpleUtcDateString = (date, format = 'DD-MMM-YYYY') =>
  moment.utc(date).format(format);

export const toFullUtcDateString = (date, format = 'DD-MMMM-YYYY') =>
  moment.utc(date).format(format);

export const toSimpleDateStringForReportReview = (
  date,
  format = 'hh:mm A, L',
) => moment(date).format(format);

export const toSimpleUtcMonthString = (date, format = 'MMM YYYY') =>
  moment.utc(date).format(format);

export const toDDMMMYY = (data, format= 'DD-MMM-YY') => moment.utc(data).format(format);

export const baseFormat = 'MMMM DD, YYYY';
